module.exports = __webpack_public_path__ + "static/c5-4a56011fec0a4f8ab3fde90b68ce885f.png";